var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointIndex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4F1A\\u6240\\u7BA1\\u7406",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6253\\u4F4D\\u7BA1\\u7406",
    transform: "translate(-1337.000000, -288.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u798F\\u5229\\u6A21\\u5757\\u5907\\u4EFD-3",
    transform: "translate(232.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(0.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4E00\\u53F7\\u6253\\u4F4D\\u5907\\u4EFD-6",
    transform: "translate(966.400000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation/Dropdown/Light/Option",
    transform: "translate(125.800000, 46.009249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "history",
    transform: "translate(12.800000, 11.990751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L14,0 L14,14 L0,14 L0,0 Z",
    id: "history-(Background)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,0.875 C3.61727905,0.875 0.875,3.61727905 0.875,7 C0.875,10.3827209 3.61727905,13.125 7,13.125 C10.3827209,13.125 13.125,10.3827209 13.125,7 C13.125,3.61727905 10.3827209,0.875 7,0.875 Z M7.036623,2 C4.27518908,2 2.036623,4.23856608 2.036623,7 C2.036623,9.76143392 4.27518908,12 7.036623,12 C9.79805692,12 12.036623,9.76143392 12.036623,7 C12.036623,4.23856608 9.79805692,2 7.036623,2 Z",
    id: "Union",
    fillOpacity: 0.85,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4767189,6.92643231 L8.39116442,8.84087783 C8.60484479,9.0545582 8.95128912,9.0545582 9.16496949,8.84087783 C9.16964697,8.83620035 9.17423924,8.83143842 9.17874405,8.82659441 C9.39068893,8.59869022 9.37775135,8.24212209 9.14984716,8.03017721 C9.14890979,8.02930548 9.14796946,8.02843695 9.14702618,8.02757164 L7.55157852,6.56399536 L7.55157852,6.56399536 L7.55157852,4.93605268 C7.55157852,4.63923839 7.310963,4.39862287 7.01414871,4.39862287 C6.71733442,4.39862287 6.4767189,4.63923839 6.4767189,4.93605268 L6.4767189,6.92643231 L6.4767189,6.92643231 Z",
    fillOpacity: 0.85,
    fill: "#000000"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointIndex);
export default __webpack_public_path__ + "static/media/appoint-index.86a802e911b97084a32c8ebb3a175ab9.svg";
export { ForwardRef as ReactComponent };